import {  Injectable } from '@angular/core';
import {DeviceInt} from "@app/interfaces/device.interface";
import {Observable, Subject} from "rxjs";
import {CussService} from "@services/cuss.service";
import { deviceIds } from 'src/embross-device-manager'
import { parsePassportInfo } from '@utils/index'
import {PassportScanInfoInt} from "@interfaces/*";
import { PAX_TYPE } from '@app/enums';

@Injectable({
  providedIn: 'root'
})
export class PassportReaderDeviceService implements DeviceInt{
  device;
  listen$: Subject<any> = new Subject<any>();
  timeoutId = undefined;
  isComplete = false;

  constructor(
    private cussService: CussService,
  ) {
    this.setDevice();
  }

  private setDevice(){
    if (this.cussService.getDeviceManager()){
      this.device = this.cussService.getDeviceManager().getDevice(deviceIds.PASSPORT_READER)
    }
  }

  disable(): void {
    if (this.device) {
      this.device.disable()
      this.device.OnDeviceEvent = null;
    }
    if(this.timeoutId){
      clearTimeout(this.timeoutId)
    }
  }

  enable(): void {
    this.setDevice();
    if (this.device) {
      this.device.OnDeviceEvent = this.callback;
      this.device.enable()
    }
  }

  read() {
    console.log('Scanner Read')
    this.device.read();
  }

  readDummy(paxType = PAX_TYPE.ADULT,firstName='',lastName='') {
    //"P<USABARFO<<FOOBA<TESTF<<<<<<<<<<<<<<<<<<<<<";
    const firstnames = firstName ? firstName.split(' ') : [];
    let track1 = `P<USA${lastName? lastName: 'DOE'}<<${firstnames?.length>0? firstnames[0]: 'JOHN'}<${firstnames?.length>1? firstnames[1]: ''}<<<<<<<<<<<<<<<<<<<<<`;
    let track2 = "";
    switch(paxType){
      case PAX_TYPE.ADULT:
        track2 = "N156377387USA9203273M2909100137449230<686906";
      break;
      case PAX_TYPE.CHILD:
        track2 = "N156377387USA1503273M2909100137449230<686906";
      break;
      case PAX_TYPE.INFANT:
        track2 = "N156377387USA2203273M2909100137449230<686906";
      break;
    }
    let passportInfo = parsePassportInfo(track1, track2);
    this.timeoutId = setTimeout(() => {
       this.timeoutId = setTimeout(() => {
         const event = {key:'passportReadInternal'}
         this.listen$.next({event,passportInfo})
       }, 1500);
    }, 1500);
  }

  getData(value): PassportScanInfoInt | undefined {
    console.log('Scanner getData' , value)
    let data;
    if (value !== '' ) {
      if(value !== undefined){
        let tracks = value.split('_@');
        let mediaData = {
          track1: tracks[0],
          track2: tracks[1],
          track3: tracks[2],
          mediaType: 'PASSPORT'
        };
        console.log('[GET_DATA_PASSPORT]', mediaData);
        data = parsePassportInfo(mediaData.track1, mediaData.track2);
        console.log('[CONVERT_DATA_PASSPORT]', data);
      }
    }
    return data;
  }

  listen(): Observable<any> {
    if (this.isComplete) {
      this.listen$ = new Subject();
    }
    return this.listen$.asObservable();
  }

  callback = (event: any) =>  {
    console.log('Scanner [EVENT_PASSPORT]', event);
    switch (event.key) {
      case 'statusIsOK':
        break;
      case 'passportDamaged':
        this.listen$.error({error: 'damage', event})
        break;
      case 'passportDataError':
        this.listen$.error({error: 'dataError', event});
        break;
      case 'passportInserted':
        break;
      case 'passportRead':
       this.listen$.next({event})
        break;
      case 'passportReadInternal':
        let response:PassportScanInfoInt = undefined;
        if (event.value !== '') {
          let tracks = event.value.split('_@');
          let mediaData = {
            track1: tracks[0],
            track2: tracks[1],
            track3: tracks[2],
            mediaType: 'PASSPORT'
          };
          console.log('[GET_DATA_PASSPORT]', mediaData);
          response = parsePassportInfo(mediaData.track1, mediaData.track2);
          console.log('[CONVERT_DATA_PASSPORT]', response);
        } else {
          console.warn('Scanned Passport is empty, try again...');
        }
        this.listen$.next({event,passportInfo:response})
        break;
      case 'passportRemoved':
        this.isComplete = true
        break;
      case 'statusChange':
        if (event.value[0] > 300 && event.value[0] < 310) {
          this.cussService.getOOSManager().completeTransaction(true);
        }
        break;
    }
  }

}
